/**
 * Initial state factory for the "member" Vuex module.
 *
 * Returned as a function (rather than a plain object) so Vuex gets a fresh,
 * unshared state tree per store instantiation.
 */
export default () => ({
  usersData: [],
  userReputationScores: {},
});
